<template>
    <div>
        <div class="header-wrap">
            <div class="header">
                <Sticky>
                    <Search placeholder="请输入场景名称" v-model="searchInput" @search="onSearch"/>
                </Sticky>
            </div>
        </div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;padding: 10px 12px;background: #f3f3f3"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <LinkageItem v-for="(item) in dataList" :key="item.id" :detail="item"/>
            </List>
        </PullRefresh>
        <pf code="LINKAGE_ADD">
            <Icon name="plus" size="35px" color="#fff" @click="$router.push('/linkage/add')" class="float-btn-add"/>
        </pf>
    </div>
    <!-- <div>
        <div key="scene" v-if="selectedBar=='scene'">
            <LinkageScene/>
        </div>
        <div key="rules" v-if="selectedBar=='rules'">
            <LinkageRules/>
        </div>
        <div key="super" v-if="selectedBar=='super'">
            <SuperLinkage/>
        </div>
        <Tabbar v-model="selectedBar">
            <TabbarItem name="scene" icon="notes-o">智能场景</TabbarItem>
            <TabbarItem name="rules" icon="notes-o">联动规则</TabbarItem>
            <TabbarItem name="super" icon="notes-o">超级联动</TabbarItem>
        </Tabbar>
    </div> -->
</template>

<script>
    import {Button, Icon, List, PullRefresh, Search, Sticky} from "vant";
    import WeChatIcon from "@/components/Icon/WeChatIcon";
    import LinkageItem from "./components/LinkageItem"
    export default {
        components: {
            LinkageItem,
            WeChatIcon, Sticky, Search, List, Button, Icon, PullRefresh
        },
        props: {},
        data() {
            return {
                isReFresh: false,
                finished: false,
                searchInput: null,
                loading: false,
                dataList: []
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onLoad(isPullRefresh) {
                this.$http.tokiot.linkage.list({
                    // fullText: this.searchInput,
                    name: this.searchInput,
                    size: 20,
                    page: Math.ceil(this.dataList.length / 20 + 1)
                })
                    .then(ret => {
                        if (ret) {
                            console.info('场景列表', ret.rows)
                            this.dataList.push(...ret.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            if (this.dataList.length >= ret.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onRefresh() {
                this.isReFresh = true;
                this.dataList = [];
                this.onLoad(true);
            },
            onSearch() {
                this.dataList = [];
                this.onLoad();
            },
        },
        watch: {}
    }
    // import {Tabbar, TabbarItem, Tabs} from "vant";
    // import LinkageScene from "./tab/LinkageScene"
    // import LinkageRules from "./tab/LinkageRules"
    // import SuperLinkage from "./tab/SuperLinkage"


    // export default {
    //     components: {
    //         Tabbar, TabbarItem,
    //         LinkageScene, LinkageRules, SuperLinkage
    //     },
    //     props: {},
    //     data() {
    //         return {
    //             selectedBar: 'scene',
    //         }
    //     },
    //     computed: {},
    //     created() {
    //     },
    //     mounted() {
    //     },
    //     methods: {},
    //     watch: {}
    // }
</script>

<style>
    .float-btn-add {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 28px;
        right: 20px;
        z-index: 999;
        padding-top: 2px;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }
</style>
